export class carddetail{
    cardnumber:string='';
    lastfourcardnumber:string='';
    cardtype:string='';
    ExpirationMonth:string='';
    ExpirationYear:any='';
    FriendlyName:string='';
    FundingId:string='';
    PaymentType:string='';
    CardSubType:string='';
    InstitutionName:string='';
    NameOnAccount:string='';
    Address:string='';
    CountryCode:string='';
    StateCode:string='';
    StateName:string='';
    City:string='';
    PostalCode:string='';
    CVV:string='';
}



// WEBPACK FOOTER //
// ./src/app/models/mywallet/card/mywallet.card.Modal.ts